module.exports = __webpack_public_path__ + "static/media/takman_technologies_logo.7775ffd1.svg";